import * as React from 'react'
import { useDispatch } from 'react-redux'
import { setIsStored } from '../redux/slices/Alerts'
import { requestDeletePublicEvent, confirmDeletePublicEvent } from '../services'

/**
 * Encapsula el flujo de borrado físico de un evento de prueba con verificación OTP.
 * Espeja el patrón usado en la tabla de árboles (TreeActions) para reutilizar
 * VerificationCodeDialog.
 */
const usePublicEventDelete = eventId => {
  const dispatch = useDispatch()
  const [requestLoading, setRequestLoading] = React.useState(false)
  const [otpDialogOpen, setOtpDialogOpen] = React.useState(false)
  const [otpLoading, setOtpLoading] = React.useState(false)
  const [otpError, setOtpError] = React.useState(null)
  const [resendCount, setResendCount] = React.useState(0)
  const [retryAfterSeconds, setRetryAfterSeconds] = React.useState(null)

  const requestDeletion = async event => {
    event?.stopPropagation?.()
    setRequestLoading(true)
    setOtpError(null)
    const result = await requestDeletePublicEvent(eventId)
    setRequestLoading(false)

    if (result?.cooldownActive) {
      setRetryAfterSeconds(result.retryAfter ?? null)
      setOtpDialogOpen(true)
    } else if (result?.requested) {
      setRetryAfterSeconds(null)
      setResendCount(c => c + 1)
      setOtpDialogOpen(true)
    } else {
      dispatch(
        setIsStored({
          stored: false,
          message: result?.message || 'Error al solicitar eliminación.',
        }),
      )
    }
  }

  const requestNewCode = async () => {
    const result = await requestDeletePublicEvent(eventId)
    if (result?.cooldownActive) {
      setRetryAfterSeconds(result.retryAfter ?? null)
      setOtpError('Espera antes de reenviar.')
    } else if (result?.requested) {
      setRetryAfterSeconds(null)
      setResendCount(c => c + 1)
      setOtpError(null)
    }
  }

  const confirmDeletion = async code => {
    setOtpLoading(true)
    setOtpError(null)
    const result = await confirmDeletePublicEvent(eventId, code)
    setOtpLoading(false)

    if (result?.action === 'deleted') {
      setOtpDialogOpen(false)
      dispatch(setIsStored({ stored: true, message: 'Evento eliminado permanentemente.' }))
    } else {
      setOtpError(result?.message || 'Código inválido o expirado.')
    }
  }

  const closeOtpDialog = () => {
    if (otpLoading) return
    setOtpDialogOpen(false)
    setOtpError(null)
  }

  return {
    requestLoading,
    otpDialogOpen,
    otpLoading,
    otpError,
    resendCount,
    retryAfterSeconds,
    requestDeletion,
    requestNewCode,
    confirmDeletion,
    closeOtpDialog,
  }
}

export default usePublicEventDelete
